module.exports = __webpack_public_path__ + "media/images/course/course_bg-701381506e6b2594b1943d85e6318d66.png";